import { Line } from './line.model';

export class LineLocation {

    public id: number;
    public value: string;
    public lineId: string;
    public line: Line;

    static mapLine(line = {}) {
        return new Line(line || {});
    }

    static get type() {
        return 'lineLocation';
    }

    constructor(location: any = {}) {
        this.id = location.id || 0;
        this.value = location.value || '';
        this.line = location.mapLine(location.line);
        this.lineId = location.lineId || 0;
    }
}
